<template>
  <div class="empty-selected-chat">
    <i class="el-icon-chat-dot-round"></i>
    <p>Select a chat to view the conversation.</p>
  </div>
</template>

<script>
export default {
  name: "EmptySelectedChat",
};
</script>

<style scoped lang="scss">
.empty-selected-chat {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;

  i {
    font-size: 50px;
    color: #606266;
  }

  p {
    margin-top: 10px;
    font-size: 26px;
    color: #606266;
  }
}
</style>
